import { Rules, Validator } from 'inpock-ui-react';

interface InputConstraint {
  rules: Rules;
  validator: Validator;
}

export const CUSTOMER_NAME: InputConstraint = {
  rules: {
    required: true,
    min_length: 2,
    max_length: 30,
  },
  validator: (_, value) => {
    const format = /^[가-힣a-zA-Z\s]+$/;

    if (!format.test(value)) {
      throw new Error('정확한 구매자명을 입력해주세요');
    }
  },
};

export const REVIEW_CONTENT: InputConstraint = {
  rules: {
    required: true,
    min_length: 10,
    max_length: 5000,
  },
  validator: () => {},
};

export const EMAIL: InputConstraint = {
  rules: {
    required: true,
    min_length: 0,
    max_length: 200,
    no_white_space: true,
  },
  validator: (_rules, value) => {
    const format =
      /^[A-Za-z0-9]([-_.]?[A-Za-z0-9_])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;

    if (!format.test(value)) {
      throw new Error('이메일 주소 형식을 확인해주세요');
    }
  },
};

export const ORDER_NUMBER: InputConstraint = {
  rules: {
    required: true,
    no_white_space: true,
    just_number: false,
  },
  validator: (_, value) => {
    const format = /^[0-9a-zA-Z]{16}$/;

    if (!format.test(value)) {
      throw new Error('정확한 주문번호를 입력해주세요');
    }
  },
};

export const CUSTOMER_PHONE: InputConstraint = {
  rules: {
    required: true,
    no_white_space: true,
    just_number: true,
    max_length: 11,
  },
  validator: (_, value) => {
    const format = /^01[0-9]{8,9}$/;

    if (!format.test(value)) {
      throw new Error('정확한 휴대폰 번호를 입력해주세요 (10자 이상)');
    }
  },
};

export const CERT_NUM_RULE: Rules = {
  required: true,
  just_number: true,
  min_length: 4,
  max_length: 4,
};

export const CUSTOMER_ADDRESS: InputConstraint = {
  rules: {
    required: true,
    max_length: 1000,
  },
  validator: () => {},
};

export const CUSTOMER_ADDRESS_DETAIL: InputConstraint = {
  rules: {
    required: true,
    min_length: 0,
    max_length: 1000,
  },
  validator: () => {},
};

export const CUSTOMER_ZIPCODE: InputConstraint = {
  rules: {
    required: true,
    max_length: 5,
    just_number: true,
  },
  validator: () => {},
};

export const DELIVERY_MESSAGE: InputConstraint = {
  rules: {
    max_length: 30,
  },
  validator: () => {},
};

export const CASH_RECEIPT_CARD: InputConstraint = {
  rules: {
    required: true,
    no_white_space: true,
    just_number: true,
  },
  validator: (_rules, value) => {
    const format = /^[0-9]{13,19}$/;

    if (!format.test(value)) {
      throw new Error('정확한 카드번호를 입력해주세요 (13자 이상)');
    }
  },
};

export const CASH_RECEIPT_BUSINESS: InputConstraint = {
  rules: {
    required: true,
    no_white_space: true,
    just_number: true,
  },
  validator: (_rules, value) => {
    const format = /^[0-9]{10,19}$/;

    if (!format.test(value)) {
      throw new Error('정확한 사업자번호를 입력해주세요');
    }
  },
};
